// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.use-cases-page {
  width: 100%;
  min-height: 100vh;
  background: #121212;
  color: #F1F1F1;
  font-family: 'Satoshi', sans-serif;
  padding-top: 120px;
}

/* ================================
   Featured Article Carousel
================================ */
.use-cases-featured-wrapper {
  position: relative;
  max-width: 1200px;
  margin: 0 auto 60px;
  padding: 0 60px;
}

.use-cases-featured {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: center;
}

.use-cases-featured-arrow {
  position: absolute;
  right: 60px;
  top: 50%;
  transform: translateY(-50%);
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.05);
  color: #F1F1F1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 10;
}

.use-cases-featured-arrow:hover {
  background: #CCFF00;
  color: #121212;
  border-color: #CCFF00;
  transform: translateY(-50%) scale(1.1);
}

.use-cases-featured-arrow:active {
  transform: translateY(-50%) scale(0.95);
}

.use-cases-featured-image {
  width: 100%;
  height: 400px;
  overflow: hidden;
  border-radius: 12px;
}

.use-cases-featured-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.use-cases-featured-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.use-cases-featured-category {
  font-size: 14px;
  font-weight: 500;
  color: #CCFF00;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.use-cases-featured-title {
  font-size: 2.5vw;
  font-weight: 500;
  line-height: 1.3;
  letter-spacing: -0.02em;
  color: #F1F1F1;
  margin: 0;
}

.use-cases-featured-description {
  font-size: 1.1vw;
  line-height: 1.6;
  color: rgba(241, 241, 241, 0.7);
  margin: 0;
}

.use-cases-featured-date {
  font-size: 14px;
  color: rgba(241, 241, 241, 0.5);
}

/* ================================
   Navigation and Search
================================ */
.use-cases-nav {
  max-width: 1200px;
  margin: 0 auto 60px;
  padding: 0 60px;
}

.use-cases-nav-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 40px;
  padding: 24px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.use-cases-filters {
  display: flex;
  gap: 8px;
}

.use-cases-filter-btn {
  padding: 8px 20px;
  border: none;
  background: transparent;
  color: rgba(241, 241, 241, 0.6);
  font-size: 16px;
  font-weight: 500;
  font-family: 'Satoshi', sans-serif;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.use-cases-filter-btn:hover {
  color: #F1F1F1;
  background: rgba(255, 255, 255, 0.05);
}

.use-cases-filter-btn.active {
  color: #CCFF00;
  background: rgba(204, 255, 0, 0.1);
}

.use-cases-search {
  display: flex;
  gap: 12px;
  align-items: center;
}

.use-cases-search-input {
  padding: 10px 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  color: #F1F1F1;
  font-size: 14px;
  font-family: 'Satoshi', sans-serif;
  outline: none;
  transition: all 0.3s ease;
  min-width: 200px;
}

.use-cases-search-input::placeholder {
  color: rgba(241, 241, 241, 0.4);
}

.use-cases-search-input:focus {
  border-color: #CCFF00;
  background: rgba(255, 255, 255, 0.08);
}

.use-cases-search-btn {
  padding: 10px 24px;
  border: 1px solid #CCFF00;
  background: #CCFF00;
  color: #121212;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Satoshi', sans-serif;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.use-cases-search-btn:hover {
  background: rgba(204, 255, 0, 0.8);
}

/* ================================
   Articles Grid
================================ */
.use-cases-articles {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 60px 80px;
}

.use-cases-articles-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  margin-bottom: 60px;
}

.use-cases-article-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  cursor: pointer;
}

.use-cases-article-card:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(204, 255, 0, 0.3);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
}

.use-cases-article-image {
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.use-cases-article-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.use-cases-article-card:hover .use-cases-article-image img {
  transform: scale(1.05);
}

.use-cases-article-content {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.use-cases-article-category {
  font-size: 12px;
  font-weight: 500;
  color: #CCFF00;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.use-cases-article-title {
  font-size: 18px;
  font-weight: 500;
  line-height: 1.4;
  color: #F1F1F1;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.use-cases-article-description {
  font-size: 14px;
  line-height: 1.6;
  color: rgba(241, 241, 241, 0.6);
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.use-cases-article-date {
  font-size: 12px;
  color: rgba(241, 241, 241, 0.4);
  margin-top: 4px;
}

/* ================================
   Load More Button
================================ */
.use-cases-load-more {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.use-cases-load-more-btn {
  padding: 14px 32px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  background: transparent;
  color: #F1F1F1;
  font-size: 16px;
  font-weight: 500;
  font-family: 'Satoshi', sans-serif;
  border-radius: 9999px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.use-cases-load-more-btn:hover {
  background: #CCFF00;
  color: #121212;
  border-color: #CCFF00;
}

/* ================================
   Mobile Responsive
================================ */
@media (max-width: 1024px) {
  .use-cases-featured {
    grid-template-columns: 1fr;
    gap: 32px;
  }

  .use-cases-featured-title {
    font-size: 3vw;
  }

  .use-cases-featured-description {
    font-size: 1.5vw;
  }

  .use-cases-articles-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }
}

@media (max-width: 768px) {
  .use-cases-page {
    padding-top: 100px;
  }

  .use-cases-featured-wrapper {
    padding: 0 20px;
  }

  .use-cases-featured-arrow {
    right: 20px;
    width: 40px;
    height: 40px;
  }

  .use-cases-featured-arrow svg {
    width: 20px;
    height: 20px;
  }

  .use-cases-featured-image {
    height: 300px;
  }

  .use-cases-featured-title {
    font-size: 24px;
  }

  .use-cases-featured-description {
    font-size: 16px;
  }

  .use-cases-nav {
    padding: 0 20px;
  }

  .use-cases-nav-container {
    flex-direction: column;
    align-items: stretch;
    gap: 20px;
  }

  .use-cases-filters {
    justify-content: center;
  }

  .use-cases-search {
    width: 100%;
  }

  .use-cases-search-input {
    flex: 1 1;
    min-width: 0;
  }

  .use-cases-articles {
    padding: 0 20px 60px;
  }

  .use-cases-articles-grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .use-cases-article-image {
    height: 180px;
  }
}

@media (max-width: 480px) {
  .use-cases-featured-wrapper {
    padding: 0 16px;
  }

  .use-cases-featured-arrow {
    right: 16px;
    width: 36px;
    height: 36px;
  }

  .use-cases-featured-arrow svg {
    width: 18px;
    height: 18px;
  }

  .use-cases-featured-image {
    height: 250px;
  }

  .use-cases-featured-title {
    font-size: 20px;
  }

  .use-cases-featured-description {
    font-size: 14px;
  }

  .use-cases-nav {
    padding: 0 16px;
  }

  .use-cases-articles {
    padding: 0 16px 40px;
  }

  .use-cases-article-content {
    padding: 20px;
  }

  .use-cases-article-title {
    font-size: 16px;
  }

  .use-cases-article-description {
    font-size: 13px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/use-cases/use-cases.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;;kCAEkC;AAClC;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;;kCAEkC;AAClC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,8CAA8C;EAC9C,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,qCAAqC;EACrC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kCAAkC;EAClC,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;kCAEkC;AAClC;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,SAAS;EACT,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;;kCAEkC;AAClC;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,qBAAqB;EACrB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;kCAEkC;AAClC;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;IACP,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".use-cases-page {\n  width: 100%;\n  min-height: 100vh;\n  background: #121212;\n  color: #F1F1F1;\n  font-family: 'Satoshi', sans-serif;\n  padding-top: 120px;\n}\n\n/* ================================\n   Featured Article Carousel\n================================ */\n.use-cases-featured-wrapper {\n  position: relative;\n  max-width: 1200px;\n  margin: 0 auto 60px;\n  padding: 0 60px;\n}\n\n.use-cases-featured {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 40px;\n  align-items: center;\n}\n\n.use-cases-featured-arrow {\n  position: absolute;\n  right: 60px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  background: rgba(255, 255, 255, 0.05);\n  color: #F1F1F1;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  z-index: 10;\n}\n\n.use-cases-featured-arrow:hover {\n  background: #CCFF00;\n  color: #121212;\n  border-color: #CCFF00;\n  transform: translateY(-50%) scale(1.1);\n}\n\n.use-cases-featured-arrow:active {\n  transform: translateY(-50%) scale(0.95);\n}\n\n.use-cases-featured-image {\n  width: 100%;\n  height: 400px;\n  overflow: hidden;\n  border-radius: 12px;\n}\n\n.use-cases-featured-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.use-cases-featured-content {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.use-cases-featured-category {\n  font-size: 14px;\n  font-weight: 500;\n  color: #CCFF00;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.use-cases-featured-title {\n  font-size: 2.5vw;\n  font-weight: 500;\n  line-height: 1.3;\n  letter-spacing: -0.02em;\n  color: #F1F1F1;\n  margin: 0;\n}\n\n.use-cases-featured-description {\n  font-size: 1.1vw;\n  line-height: 1.6;\n  color: rgba(241, 241, 241, 0.7);\n  margin: 0;\n}\n\n.use-cases-featured-date {\n  font-size: 14px;\n  color: rgba(241, 241, 241, 0.5);\n}\n\n/* ================================\n   Navigation and Search\n================================ */\n.use-cases-nav {\n  max-width: 1200px;\n  margin: 0 auto 60px;\n  padding: 0 60px;\n}\n\n.use-cases-nav-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 40px;\n  padding: 24px 0;\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.use-cases-filters {\n  display: flex;\n  gap: 8px;\n}\n\n.use-cases-filter-btn {\n  padding: 8px 20px;\n  border: none;\n  background: transparent;\n  color: rgba(241, 241, 241, 0.6);\n  font-size: 16px;\n  font-weight: 500;\n  font-family: 'Satoshi', sans-serif;\n  cursor: pointer;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n}\n\n.use-cases-filter-btn:hover {\n  color: #F1F1F1;\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.use-cases-filter-btn.active {\n  color: #CCFF00;\n  background: rgba(204, 255, 0, 0.1);\n}\n\n.use-cases-search {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.use-cases-search-input {\n  padding: 10px 16px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 8px;\n  color: #F1F1F1;\n  font-size: 14px;\n  font-family: 'Satoshi', sans-serif;\n  outline: none;\n  transition: all 0.3s ease;\n  min-width: 200px;\n}\n\n.use-cases-search-input::placeholder {\n  color: rgba(241, 241, 241, 0.4);\n}\n\n.use-cases-search-input:focus {\n  border-color: #CCFF00;\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.use-cases-search-btn {\n  padding: 10px 24px;\n  border: 1px solid #CCFF00;\n  background: #CCFF00;\n  color: #121212;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: 'Satoshi', sans-serif;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.use-cases-search-btn:hover {\n  background: rgba(204, 255, 0, 0.8);\n}\n\n/* ================================\n   Articles Grid\n================================ */\n.use-cases-articles {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 60px 80px;\n}\n\n.use-cases-articles-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 32px;\n  margin-bottom: 60px;\n}\n\n.use-cases-article-card {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  overflow: hidden;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.use-cases-article-card:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(204, 255, 0, 0.3);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);\n}\n\n.use-cases-article-image {\n  width: 100%;\n  height: 200px;\n  overflow: hidden;\n}\n\n.use-cases-article-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n.use-cases-article-card:hover .use-cases-article-image img {\n  transform: scale(1.05);\n}\n\n.use-cases-article-content {\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.use-cases-article-category {\n  font-size: 12px;\n  font-weight: 500;\n  color: #CCFF00;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.use-cases-article-title {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 1.4;\n  color: #F1F1F1;\n  margin: 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.use-cases-article-description {\n  font-size: 14px;\n  line-height: 1.6;\n  color: rgba(241, 241, 241, 0.6);\n  margin: 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.use-cases-article-date {\n  font-size: 12px;\n  color: rgba(241, 241, 241, 0.4);\n  margin-top: 4px;\n}\n\n/* ================================\n   Load More Button\n================================ */\n.use-cases-load-more {\n  display: flex;\n  justify-content: center;\n  margin-top: 40px;\n}\n\n.use-cases-load-more-btn {\n  padding: 14px 32px;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  background: transparent;\n  color: #F1F1F1;\n  font-size: 16px;\n  font-weight: 500;\n  font-family: 'Satoshi', sans-serif;\n  border-radius: 9999px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.use-cases-load-more-btn:hover {\n  background: #CCFF00;\n  color: #121212;\n  border-color: #CCFF00;\n}\n\n/* ================================\n   Mobile Responsive\n================================ */\n@media (max-width: 1024px) {\n  .use-cases-featured {\n    grid-template-columns: 1fr;\n    gap: 32px;\n  }\n\n  .use-cases-featured-title {\n    font-size: 3vw;\n  }\n\n  .use-cases-featured-description {\n    font-size: 1.5vw;\n  }\n\n  .use-cases-articles-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 24px;\n  }\n}\n\n@media (max-width: 768px) {\n  .use-cases-page {\n    padding-top: 100px;\n  }\n\n  .use-cases-featured-wrapper {\n    padding: 0 20px;\n  }\n\n  .use-cases-featured-arrow {\n    right: 20px;\n    width: 40px;\n    height: 40px;\n  }\n\n  .use-cases-featured-arrow svg {\n    width: 20px;\n    height: 20px;\n  }\n\n  .use-cases-featured-image {\n    height: 300px;\n  }\n\n  .use-cases-featured-title {\n    font-size: 24px;\n  }\n\n  .use-cases-featured-description {\n    font-size: 16px;\n  }\n\n  .use-cases-nav {\n    padding: 0 20px;\n  }\n\n  .use-cases-nav-container {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 20px;\n  }\n\n  .use-cases-filters {\n    justify-content: center;\n  }\n\n  .use-cases-search {\n    width: 100%;\n  }\n\n  .use-cases-search-input {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .use-cases-articles {\n    padding: 0 20px 60px;\n  }\n\n  .use-cases-articles-grid {\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n\n  .use-cases-article-image {\n    height: 180px;\n  }\n}\n\n@media (max-width: 480px) {\n  .use-cases-featured-wrapper {\n    padding: 0 16px;\n  }\n\n  .use-cases-featured-arrow {\n    right: 16px;\n    width: 36px;\n    height: 36px;\n  }\n\n  .use-cases-featured-arrow svg {\n    width: 18px;\n    height: 18px;\n  }\n\n  .use-cases-featured-image {\n    height: 250px;\n  }\n\n  .use-cases-featured-title {\n    font-size: 20px;\n  }\n\n  .use-cases-featured-description {\n    font-size: 14px;\n  }\n\n  .use-cases-nav {\n    padding: 0 16px;\n  }\n\n  .use-cases-articles {\n    padding: 0 16px 40px;\n  }\n\n  .use-cases-article-content {\n    padding: 20px;\n  }\n\n  .use-cases-article-title {\n    font-size: 16px;\n  }\n\n  .use-cases-article-description {\n    font-size: 13px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
